import React from "react";
import { Flex } from "../../atoms/flex";

interface Props {
  tag: "h1" | "h2" | "h3" | "h4" | "h5";
}

/**
 * Title skeleton
 */

export const TitleSkeleton: React.FC<Props> = ({ tag }) => (
  <Flex>
    <div
      className={
        tag === "h1" || tag === "h2" ? "headerLoading" : "headerSubtitleLoading"
      }
    />
  </Flex>
);
